import Criteo from 'lib/Criteo';
import FacebookPixel from 'lib/FacebookPixel';
import GoogleAdWords from 'lib/GoogleAdWords';

export function trackListingsView(vins: string[], searchString: string): void {
  const trimmedVins = vins.slice(0, 5);

  Criteo.trackListingsView(vins, searchString);
  FacebookPixel.trackListingsView(vins);
  GoogleAdWords.trackListingsView(trimmedVins);
}
